module.exports = __webpack_public_path__ + "static/media/7-6.d1efe751.mp3";